// extracted by mini-css-extract-plugin
export default {"reviews":"reviews--k0Vq","green":"green--Vidf","orange":"orange--Iyx5","red":"red--Rb2L","bold":"bold--2zBM"};